module.exports = __webpack_public_path__ + "static/media/top-rated-1.dd42d560.png";